import "../styles/InHouseFacilities.css";

// dummy images (replace with your real ones later)
import ProductDesignOffice from "../images/ProductDesignOffice.jpeg";
import UnitAssyLine from "../images/UnitAssyLine.jpeg";
import ELTTestingLab from "../images/ELTTestingLab.jpeg";
import PerformanceTestingLab from "../images/PerformanceTestingLab.jpeg";
import YANGLICNCTurret40STN from "../images/YANGLICNCTurret-40STN.jpeg";
import CNCPRESSBRAKE from "../images/CNCPRESSBRAKE.jpeg";
// import img7 from "../images/paint.jpeg";

export default function InhouseFacilities() {
  const facilities = [
    { name: "Product Design Office", img: ProductDesignOffice },
    { name: "Unit Assembly Line", img: UnitAssyLine },
    { name: "ELT Testing Lab", img: ELTTestingLab },
    { name: "Performance Testing Lab", img: PerformanceTestingLab },
    { name: "YANGLI CNC Turret - 40STN", img: YANGLICNCTurret40STN },
    { name: "CNC Press Brake", img: CNCPRESSBRAKE },
    // { name: "GEMA Germany Paint Shop", img: img7 }
  ];

  return (
    <section className="inhouse-section">

      <div className="container">

        {/* HEADER */}
        <div className="inhouse-header">
          <h2>In House Facilities</h2>
          <p>
            Advanced manufacturing infrastructure ensuring precision, quality and efficiency
          </p>
        </div>

        {/* GRID */}
        <div className="facility-image-grid">

          {facilities.map((item, index) => (
            <div className="facility-image-card" key={index}>

              <img src={item.img} alt={item.name} />

              <div className="overlay">
                <h3>{item.name}</h3>
              </div>

            </div>
          ))}

        </div>

      </div>

    </section>
  );
}